<template>
	<v-container fluid>
		<v-row>
			<v-col cols="12">
				<v-btn class="mr-1" color="primary" @click="addPaymentFormClick">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.addPaymentForm') }}
				</v-btn>
				<v-btn class="mr-1" color="primary" @click="addPaymentClick">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.addPayment') }}
				</v-btn>
				<v-btn class="mr-1" color="primary" @click="addXMLPaymentClick">
					<v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.addXMLPayment') }}
				</v-btn>
			</v-col>
		</v-row>
		<v-row>
			<v-col cols="12">
				<v-row class="pl-3 mb-2">
					<v-btn
						small
						:color="fastFilterPaymentForms == 0 ? 'primary' : ''"
						@click="fastFilterPaymentForms = 0"
						class="mr-2"
						>Sve uplatnice</v-btn
					>
					<v-btn
						small
						:color="fastFilterPaymentForms == 1 ? 'primary' : ''"
						@click="fastFilterPaymentForms = 1"
						class="mr-2"
						>Otvorene uplatnice</v-btn
					>
					<v-btn
						small
						:color="fastFilterPaymentForms == 2 ? 'primary' : ''"
						@click="fastFilterPaymentForms = 2"
						class="mr-2"
						>Uplatnice s uplatom</v-btn
					>
				</v-row>
				<v-card flat outlined>
					<v-card-text>
						<v-row>
							<v-col>
								<TheTable
									:additional-filters="paymentsTable.additionalFilters"
									:default-sort="paymentsTable.defaultSort"
									:excel="true"
									:fields="paymentsTable.headers"
									:header-selection-key="'payments-headers'"
									:filter-save-key="'payments-filters'"
									:height="paymentsTable.height"
									:total-records="paymentsTable.total"
									@excel="excelExport"
									@headers="selectHeaders"
									@reload="reloadData"
								>
									<tr
										v-for="(item, key) in paymentsTable.items"
										:key="key"
										:class="{ 'cursor-pointer': true }"
										@contextmenu.prevent="editPaymentClick(props.item)"
									>
										<td
											v-if="paymentsTable.selectedHeaders.includes('date')"
											@click="editPaymentClick(item)"
										>
											{{ item.date_display }}
										</td>
										<td
											v-if="paymentsTable.selectedHeaders.includes('reference_number')"
											@click="editPaymentClick(item)"
										>
											{{ item.reference_number }}
										</td>
										<td
											v-if="paymentsTable.selectedHeaders.includes('category')"
											@click="editPaymentClick(item)"
										>
											{{ item.payment_category.name }}
										</td>
										<td
											v-if="paymentsTable.selectedHeaders.includes('member')"
											@click="openMember(item.member_id)"
										>
											{{ item.member.first_name }}&nbsp;{{ item.member.last_name }}&nbsp;-&nbsp;{{
												item.member.membership_id
											}}
										</td>
										<td
											v-if="paymentsTable.selectedHeaders.includes('branch')"
											@click="editPaymentClick(item)"
										>
											{{ item.member_branch_display }}
										</td>
										<td
											v-if="paymentsTable.selectedHeaders.includes('payment_form_amount')"
											@click="editPaymentClick(item)"
										>
											{{ item.amount }}
										</td>
										<td
											v-if="paymentsTable.selectedHeaders.includes('payment_amount')"
											@click="editPaymentClick(item)"
										>
											{{ item.payment_amount_display }}
										</td>
										<td
											v-if="paymentsTable.selectedHeaders.includes('payment_date')"
											@click="editPaymentClick(item)"
										>
											{{ item.payment_date_display }}
										</td>
										<td
											v-if="paymentsTable.selectedHeaders.includes('magazines')"
											@click="editPaymentClick(item)"
										>
											{{ item.magazine_display }}
										</td>
										<td
											v-if="paymentsTable.selectedHeaders.includes('pdf_download')"
											@click="downloadPdfClick(item)"
										>
											<v-icon small color="red">fa-file-pdf</v-icon>
										</td>
										<td v-if="paymentsTable.selectedHeaders.includes('payment_delete')">
											<v-icon
												small
												color="gray"
												v-if="item.payment_id != null"
												@click="deletePayment(item)"
												>fa-trash</v-icon
											>
											<v-icon v-else small color="#E0E0E0" style="cursor: default"
												>fa-trash</v-icon
											>
										</td>
									</tr>
								</TheTable>
							</v-col>
						</v-row>
					</v-card-text>
				</v-card>
			</v-col>
		</v-row>
		<v-dialog v-model="paymentFormModalShow" width="90%" persistent>
			<v-card>
				<v-card-title>Nova Uplatnica</v-card-title>
				<v-row wrap class="ma-0 pa-5">
					<v-col cols="8" class="ma-0 pa-0">
						<v-row class="ma-0 pa-0">
							<v-col cols="6" class="ma-0 pl-5">
								<v-row>
									<v-col cols="4" class="my-1 py-0"> * Datum </v-col>
									<v-col cols="8" class="my-1 py-0">
										<DatePicker
											v-model="paymentForm.date"
											:errorBorder="!paymentFormValidation.date"
										>
										</DatePicker>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0"> * Kategorija </v-col>
									<v-col cols="8" class="my-1 py-0">
										<Dropdown
											v-model="paymentForm.payment_category_id"
											:ajax="true"
											:data="'payment-categories'"
											:errorBorder="!paymentFormValidation.payment_category_id"
										></Dropdown>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0" v-if="paymentForm.payment_category_id != 3">
										* Iznos
									</v-col>
									<v-col cols="4" class="my-1 py-0" v-else> * Iznos članarine </v-col>
									<v-col
										cols="8"
										class="my-1 py-0"
										:class="paymentForm.default_amounts ? 'read-only-class' : ''"
									>
										<CurrencyField
											:readonly="paymentForm.default_amounts"
											v-model="paymentForm.amount"
											:errorBorder="!paymentFormValidation.amount"
											:suffix="'€'"
										></CurrencyField>
									</v-col>
								</v-row>
								<v-row v-if="paymentForm.payment_category_id == 3">
									<v-col cols="4" class="my-1 py-0"> * Iznos poštarine </v-col>
									<v-col
										cols="8"
										class="my-1 py-0"
										:class="paymentForm.default_amounts ? 'read-only-class' : ''"
									>
										<CurrencyField
											:readonly="paymentForm.default_amounts"
											v-model="paymentForm.postage_amount"
											:errorBorder="!paymentFormValidation.postage_amount"
											:suffix="'€'"
										></CurrencyField>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0"></v-col>
									<v-col cols="7" class="my-1 py-0">
										<CheckBox
											class="mt-0"
											v-model="paymentForm.default_amounts"
											label="Predodređeni iznosi"
											:readonly="defaultAmountsReadOnly"
										></CheckBox>
									</v-col>
									<v-col cols="1" class="my-1 py-0">
										<v-tooltip bottom>
											<template v-slot:activator="{ on, attrs }">
												<v-icon small v-bind="attrs" v-on="on">fa-circle-info</v-icon>
											</template>
											<p class="mb-0">{{ $t('tooltips.defaultAmounts1') }}</p>
											<p class="mb-0">{{ $t('tooltips.defaultAmounts2') }}</p>
											<p class="mb-0">{{ $t('tooltips.defaultAmounts3') }}</p>
										</v-tooltip>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0"> * Datum dospijeća</v-col>
									<v-col cols="8" class="my-1 py-0">
										<DatePicker
											v-model="paymentForm.due_date"
											:errorBorder="!paymentFormValidation.due_date"
										>
										</DatePicker>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0"> * Tekst na računu </v-col>
									<v-col cols="8" class="my-1 py-0">
										<Dropdown
											v-model="paymentForm.invoice_text"
											:ajax="true"
											:data="'payment-form-invoice-texts'"
											:errorBorder="!paymentFormValidation.invoice_text"
										></Dropdown>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0"> * Slanje </v-col>
									<v-col cols="8" class="my-1 py-0">
										<v-radio-group
											dense
											class="mt-1"
											v-model="paymentForm.payment_form_delivery_type_id"
										>
											<v-radio label="Email" :value="1"></v-radio>
											<v-radio label="Pošta" :value="2"></v-radio>
											<v-radio label="Predefinirano" :value="3"></v-radio>
										</v-radio-group>
									</v-col>
								</v-row>
							</v-col>
							<v-col cols="6" class="ma-0 pl-5">
								<v-row>
									<v-col cols="4" class="my-1 py-0"> Član </v-col>
									<v-col cols="8" class="my-1 py-0">
										<InputField v-model="paymentFormFilters.name"></InputField>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0"> Odjel/ogranak </v-col>
									<v-col cols="8" class="my-1 py-0">
										<Dropdown
											v-model="paymentFormFilters.branch"
											:ajax="true"
											:data="'branches-croatia'"
											:clearable="true"
										></Dropdown>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0"> Status člana </v-col>
									<v-col cols="8" class="my-1 py-0">
										<DropdownMultiple
											v-model="paymentFormFilters.membershipStatus"
											:ajax="true"
											:data="'membership-statuses'"
											:clearable="true"
										></DropdownMultiple>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0"> Datum upisa </v-col>
									<v-col cols="4" class="my-1 py-0">
										<DatePicker
											v-model="paymentFormFilters.entryDateFrom"
											:errorBorder="!paymentFormFiltersValidationEntryDate"
											:clearable="true"
										></DatePicker>
									</v-col>
									<v-col cols="4" class="my-1 py-0">
										<DatePicker
											v-model="paymentFormFilters.entryDateTo"
											:errorBorder="!paymentFormFiltersValidationEntryDate"
											:clearable="true"
										></DatePicker>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0"> Istek članarine </v-col>
									<v-col cols="4" class="my-1 py-0">
										<DatePicker
											v-model="paymentFormFilters.expirationFrom"
											:errorBorder="!paymentFormFiltersValidationExpirationDate"
											:clearable="true"
										></DatePicker>
									</v-col>
									<v-col cols="4" class="my-1 py-0">
										<DatePicker
											v-model="paymentFormFilters.expirationTo"
											:errorBorder="!paymentFormFiltersValidationExpirationDate"
											:clearable="true"
										></DatePicker>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0"></v-col>
									<v-col cols="8" class="my-1 py-0">
										<CheckBox
											class="mt-1"
											v-model="paymentFormFilters.noMembership"
											label="Nikad nisu uplatili članarinu"
										></CheckBox>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0"> Vrsta </v-col>
									<v-col cols="8" class="my-1 py-0">
										<v-radio-group
											row
											dense
											class="mt-1 mb-2"
											hide-details
											v-model="paymentFormFilters.branchType"
											mandatory
										>
											<v-radio label="Svi" :value="0"></v-radio>
											<v-radio label="Ogranak" :value="2"></v-radio>
											<v-radio label="Odjel" :value="1"></v-radio>
										</v-radio-group>
									</v-col>
								</v-row>
								<v-row>
									<v-col cols="4" class="my-1 py-0">&nbsp;</v-col>
									<v-col cols="8" class="my-1 py-0">
										<v-btn color="primary" @click="getPaymentFormMembers">Filtriraj</v-btn>
									</v-col>
								</v-row>
							</v-col>
						</v-row>
						<v-row class="ma-0 pa-0">
							<v-col cols="2" class="ma-0 pl-5"> </v-col>
							<v-col cols="10">
								<TextArea :rows="4" v-model="selectedInvoiceText"></TextArea>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="4" class="mt-4" style="border: 1px solid #a1a1a1; border-radius: 5px">
						<v-row v-if="paymentFormMembers.length > 0">
							<v-col cols="12" class="mt-0 pt-0">
								<v-data-table
									class="profile-data-table"
									dense
									:headers="paymentFormMembersHeaders"
									:items="paymentFormMembers"
									item-key="id"
									:single-select="false"
									:show-select="true"
									v-model="selectedPaymentFormMembers"
									:items-per-page="50"
									:hide-default-footer="false"
									:height="480"
									fixed-header
									:footer-props="{ 'items-per-page-options': [50, 500, 1000, 2000, -1] }"
								></v-data-table>
							</v-col>
						</v-row>
						<v-row v-else>
							<v-col cols="12" class="d-flex justify-center" style="color: grey">
								Nema članova koji odgovaraju zadanim filterima
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row wrap class="ma-0 pa-5">
					<v-col cols="12" class="ma-0 d-flex justify-center">
						<v-btn class="mr-3" color="primary" @click="generatePaymentForms(false)"
							>Generiraj uplatnice</v-btn
						>
						<v-btn class="mr-3" @click="generatePaymentForms(true)">Preview</v-btn>
						<v-btn class="mr-3" @click="addPaymentFormClose">Odustani</v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog>
		<v-dialog v-model="paymentModalShow" width="80%" persistent>
			<v-card>
				<v-card-title>Nova Uplata</v-card-title>
				<v-row wrap class="ma-0 pa-5">
					<v-col cols="6" class="ma-0 pl-5">
						<v-row>
							<v-col cols="4" class="my-1 py-0"> Datum </v-col>
							<v-col cols="8" class="my-1 py-0">
								<DatePicker v-model="payment.date" :errorBorder="!paymentValidation.date"> </DatePicker>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="4" class="my-1 py-0"> Iznos </v-col>
							<v-col cols="8" class="my-1 py-0">
								<CurrencyField
									v-model="payment.amount"
									:errorBorder="!paymentValidation.amount"
									:suffix="'€'"
								></CurrencyField>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="4" class="my-1 py-0"> Broj izvoda </v-col>
							<v-col cols="8" class="my-1 py-0">
								<InputField
									v-model="payment.excerpt_number"
									:errorBorder="!paymentValidation.excerpt_number"
								></InputField>
							</v-col>
						</v-row>
					</v-col>
					<v-col cols="6" class="ma-0 pl-5">
						<v-row>
							<v-col cols="4" class="my-1 py-0"> Uplatnice (Poziv na broj) </v-col>
							<v-col cols="8" class="my-1 py-0">
								<Dropdown
									v-model="payment.payment_form_id"
									:ajax="true"
									:data="'payment-forms'"
									:errorBorder="!paymentValidation.payment_form_id"
								></Dropdown>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="4" class="my-1 py-0"> Kategorija </v-col>
							<v-col cols="8" class="my-1 py-0 read-only-class">
								<InputField :readonly="true" v-model="payment.category_display"></InputField>
							</v-col>
						</v-row>
						<v-row>
							<v-col cols="4" class="my-1 py-0"> Član </v-col>
							<v-col cols="8" class="my-1 py-0 read-only-class">
								<InputField :readonly="true" v-model="payment.member_display"></InputField>
							</v-col>
						</v-row>
					</v-col>
				</v-row>
				<v-row wrap class="mt-5 ma-0 pa-5">
					<v-col cols="12" class="ma-0 d-flex justify-center">
						<v-btn class="mr-3" @click="savePaymentClick" color="primary">Spremi</v-btn>
						<v-btn class="mr-3" @click="addPaymentClose">Odustani</v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog>
		<v-dialog v-model="XMLpaymentModalShow" width="80%">
			<v-card style="color: rgb(81, 81, 81)">
				<v-row wrap class="ma-0 px-5 pt-5">
					<v-col cols="12" class="ma-0 pl-2 pa-0">Nova XML uplata</v-col>
				</v-row>
				<v-row wrap class="ma-0 pa-5">
					<Upload style="width: 100%" :key="uploadKey" v-model="uploadedXMLFile" :accept="'.xml'"></Upload>
				</v-row>
				<v-row wrap class="ma-0 py-0 px-5" v-if="XMLResults != null">
					<v-col cols="7" class="ma-0 pa-0">
						<v-row wrap class="px-3 pb-3" style="font-weight: bold"> Uplate povezane s uplatnicama </v-row>
					</v-col>
					<v-col cols="5" class="ma-0 pa-0">
						<v-row wrap class="px-3 pb-3" style="font-weight: bold"> Rezultati uvoza XML datoteke </v-row>
					</v-col>
				</v-row>
				<v-row wrap class="ma-0 px-5 pb-5" v-if="XMLResults != null">
					<v-col
						cols="7"
						style="
							height: 430px;
							overflow-y: auto;
							overflow-x: hidden;
							scrollbar-color: #888888 rgb(203, 203, 203);
							scrollbar-width: thin;
						"
					>
						<v-row wrap v-for="entry in XMLResults.matchedPaymentForms" :key="entry.reference_number">
							<span v-if="entry.member != null"
								>{{ entry.member.first_name }} {{ entry.member.last_name }} -
								{{ entry.member.membership_id }} -&nbsp;</span
							>{{ entry.reference_number }} -&nbsp;<span v-if="entry.payment_category != null"
								>{{ entry.payment_category.name }} -&nbsp;</span
							>{{ entry.amount }} €
						</v-row>
					</v-col>
					<v-col
						cols="5"
						style="
							height: 430px;
							overflow-y: auto;
							overflow-x: hidden;
							scrollbar-color: #888888 rgb(203, 203, 203);
							scrollbar-width: thin;
							border: 1px solid rgb(184, 184, 184);
							border-radius: 3px;
							padding-inline: 20px;
						"
					>
						<v-row wrap>
							<span>Broj uspješno unesenih uplata prilikom XML uvoza:</span><v-spacer></v-spacer
							><span style="font-weight: bold">{{ XMLResults.matchedEntries.length }}</span>
						</v-row>
						<v-row wrap>
							<span>Broj duplih unosa prilikom XML uvoza:</span><v-spacer></v-spacer
							><span style="font-weight: bold">{{ XMLResults.duplicateEntries.length }}</span>
						</v-row>
						<v-row wrap>
							<span>Broj nepovezanih uplata prilikom XML uvoza:</span><v-spacer></v-spacer
							><span style="font-weight: bold">{{ XMLResults.unmatchedEntries.length }}</span>
						</v-row>
						<v-row wrap class="pt-2"> Popis nepovezanih uplata: </v-row>
						<v-row wrap v-if="XMLResults.unmatchedEntries.length > 0">
							<ul>
								<li v-for="entry in XMLResults.unmatchedEntries" :key="entry.reference_number">
									{{ entry.referenceNumber }} - {{ entry.amount }} €
								</li>
							</ul>
						</v-row>
						<v-row v-else class="pl-3"> - </v-row>
						<v-row wrap class="pt-2"> Popis duplih unosa: </v-row>
						<v-row wrap v-if="XMLResults.duplicateEntries.length > 0">
							<ul>
								<li v-for="entry in XMLResults.duplicateEntries" :key="entry.reference_number">
									{{ entry.referenceNumber }} - {{ entry.amount }} €
								</li>
							</ul>
						</v-row>
						<v-row v-else class="pl-3"> - </v-row>
					</v-col>
				</v-row>
				<v-row wrap class="ma-0 pa-5">
					<v-col cols="12" class="ma-0 d-flex justify-center">
						<v-btn color="primary" @click="addXMLPaymentSave">Spremi</v-btn>
						<v-btn class="ml-3" @click="addXMLPaymentClose">Odustani</v-btn>
					</v-col>
				</v-row>
			</v-card>
		</v-dialog>
	</v-container>
</template>

<script>
import Upload from '../../trinkets/Upload';
import Payment from '../../../models/Payment';
import TheTable from '../../trinkets/TheTable';
import TextArea from '../../trinkets/TextArea';
import Dropdown from '../../trinkets/Dropdown';
import CheckBox from '../../trinkets/CheckBox';
import InputField from '../../trinkets/InputField';
import PaymentForm from '../../../models/PaymentForm';
import CurrencyField from '../../trinkets/CurrencyField';
import DatePicker from '@/components/trinkets/DatePicker';
import DropdownMultiple from '../../trinkets/DropdownMultiple';

export default {
	name: 'Payments',
	components: {
		CheckBox,
		InputField,
		Dropdown,
		TextArea,
		DatePicker,
		TheTable,
		CurrencyField,
		DropdownMultiple,
		Upload,
	},
	data: function () {
		return {
			initialPaymentFormMembersLoad: false,
			payment: new Payment({}),
			paymentValidation: new Payment({}, true),
			XMLpayment: [],
			paymentForm: new PaymentForm({}),
			paymentFormValidation: new PaymentForm({}, true),
			paymentModalShow: false,
			XMLpaymentModalShow: false,
			uploadKey: 0,
			uploadedXMLFile: null,
			XMLResults: null,
			paymentFormModalShow: false,
			paymentsTable: {
				selectedHeaders: [],
				headers: [
					{ text: this.$t('fields.paymentFormDate'), value: 'date', type: 'date', allowFilter: true },
					{
						text: this.$t('fields.paymentFormReferenceNumber'),
						value: 'reference_number',
						type: 'string',
						allowFilter: true,
					},
					{
						text: this.$t('fields.paymentFormCategory'),
						value: 'category',
						type: 'multiple|payment-categories-only',
						allowFilter: true,
					},
					{ text: this.$t('fields.member'), value: 'member', type: 'dropdown|members', allowFilter: true },
					{
						text: this.$t('fields.membershipBranch'),
						value: 'branch',
						type: 'dropdown|branches',
						allowFilter: true,
					},
					{
						text: this.$t('fields.paymentForm'),
						value: 'payment_form_amount',
						type: 'price',
						allowFilter: true,
					},
					{
						text: this.$t('fields.payment'),
						value: 'payment_amount',
						type: 'price',
						allowFilter: true,
					},
					{
						text: this.$t('fields.paymentDate'),
						value: 'payment_date',
						type: 'date',
						allowFilter: true,
					},
					{
						text: this.$t('fields.magazine'),
						value: 'magazines',
						type: 'dropdown|magazines',
						allowFilter: true,
					},
					{
						text: this.$t('fields.pdfDownload'),
						value: 'pdf_download',
						type: '',
						allowFilter: false,
					},
					{
						text: this.$t('fields.deletePayment'),
						value: 'payment_delete',
						type: '',
						allowFilter: false,
					},
				],
				additionalFilters: [
					{
						text: this.$t('fields.paymentDate'),
						value: 'payment_date',
						type: 'date_range',
						allowFilter: true,
					},
				],
				items: [],
				total: 0,
				lastRequest: null,
				height: '0px',
				defaultSort: {
					field: 'date',
					descending: true,
				},
			},
			paymentFormFilters: new Object(),
			paymentFormMembers: [],
			paymentFormMembersHeaders: [
				{ text: 'Ime', value: 'first_name' },
				{ text: 'Prezime', value: 'last_name' },
				{ text: 'Članski broj', value: 'membership_id' },
			],
			selectedPaymentFormMembers: [],
			selectedInvoiceText: null,
			defaultAmountsReadOnly: false,
			fastFilterPaymentForms: 0,
			paymentFormFiltersValidationEntryDate: true,
			paymentFormFiltersValidationExpirationDate: true,
		};
	},
	watch: {
		'fastFilterPaymentForms': {
			handler: function () {
				this.reloadData(this.paymentsTable.lastRequest);
			},
			deep: true,
		},
		/* 'paymentFormFilters': {
			handler: function () {
				if (this.initialPaymentFormMembersLoad) {
					this.getPaymentFormMembers();
				}
			},
			deep: true,
		}, */
		'paymentForm.invoice_text': {
			handler: function (newVal, oldVal) {
				if (newVal != oldVal) {
					this.selectedInvoiceText = newVal;
				}
			},
		},
		'payment.payment_form_id': {
			handler: function (newVal, oldVal) {
				if (newVal != oldVal) {
					this.getPaymentCategoryAndMember(newVal);
				}
			},
		},
		'paymentForm.payment_category_id': {
			handler: function (newVal, oldVal) {
				/* if (newVal == 4) {
					this.defaultAmountsReadOnly = true;
					this.paymentForm.default_amounts = false;
				} else {
					this.defaultAmountsReadOnly = false;
				} */
			},
		},
		'uploadedXMLFile': {
			handler: function (newVal) {
				if (newVal != undefined && newVal != null) {
					if (newVal.link != '' && newVal.name != '') {
						this.processUploadedXml();
					}
				}
			},
		},
	},
	methods: {
		deletePayment(item) {
			this.$verify(this.$t('alerts.deletePaymentQuestion'), (result) => {
				if (result) {
					this.$APICall('post', 'payment-delete', { paymentId: item.payment_id }, (data, success) => {
						if (success) {
							this.$notify(this.$t('alerts.paymentDeleted'));
							this.reloadData(this.paymentsTable.lastRequest);
						} else {
							this.$alert(vm.$t('alerts.basicError'));
						}
					});
				}
			});
		},
		processUploadedXml() {
			if (this.uploadedXMLFile != null) {
				let vm = this;
				this.$APICall(
					'post',
					'payment-xml-import',
					{ uploadedXMLFile: this.uploadedXMLFile },
					(data, success) => {
						if (success) {
							vm.XMLResults = data;
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					}
				);
			}
		},
		addPaymentFormClick() {
			let currentDate = new Date();
			let lastDayOfMonth = new Date(currentDate.getFullYear(), currentDate.getMonth() + 1, 0, 12, 0, 0);
			this.paymentForm.due_date = lastDayOfMonth.toISOString().split('T')[0];

			this.paymentFormModalShow = true;
		},
		addPaymentFormClose() {
			this.paymentForm = new PaymentForm({});
			this.paymentFormValidation = new PaymentForm({}, true);
			this.selectedPaymentFormMembers = [];
			this.paymentFormModalShow = false;
		},
		addPaymentClick() {
			this.paymentModalShow = true;
		},
		addPaymentClose() {
			this.payment = new Payment({});
			this.paymentValidation = new Payment({}, true);
			this.paymentModalShow = false;
		},
		addXMLPaymentClick() {
			this.XMLpaymentModalShow = true;
		},
		addXMLPaymentSave() {
			if (this.uploadedXMLFile != null) {
				let vm = this;
				this.$APICall('post', 'payment-xml-import-save', { XMLResults: this.XMLResults }, (data, success) => {
					if (success) {
						vm.addXMLPaymentClose();
						this.reloadData(this.paymentsTable.lastRequest);
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
		addXMLPaymentClose() {
			this.uploadedXMLFile = null;
			this.XMLResults = null;
			this.uploadKey += 1;
			this.XMLpaymentModalShow = false;
		},
		editPaymentClick(paymentForm) {
			if (paymentForm.payment_id == null) {
				this.addPaymentClick();
				this.$nextTick(() => {
					this.payment.payment_form_id = paymentForm.id;
				});
			}
		},
		openMember(memberId) {
			if (memberId) {
				let routeData = this.$router.resolve('/members/' + memberId);
				window.open(routeData.href, '_blank');
			}
		},
		downloadPdfClick(paymentForm) {
			this.$APICall(
				'get',
				'payment-form-pdf/' + paymentForm.id,
				{},
				(data, success) => {
					if (success) {
						if (data != null && data != undefined && data != '') {
							window.open(data);
						}
					} else {
						this.$alert(this.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		selectHeaders(headers) {
			this.paymentsTable.selectedHeaders = headers;
		},
		reloadData(request) {
			this.paymentsTable.lastRequest = request;
			request.fastFilterPaymentForms = this.fastFilterPaymentForms;
			let vm = this;
			this.$APICall(
				'get',
				'payment-forms',
				request,
				(data, success) => {
					if (success) {
						vm.paymentsTable.items = data.items;
						vm.paymentsTable.total = data.total;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				true
			);
		},
		getPaymentFormMembers() {
			let success = true;
			if (this.paymentFormFilters.entryDateFrom != null && this.paymentFormFilters.entryDateTo != null) {
				let tempFrom = new Date(this.paymentFormFilters.entryDateFrom);
				let tempTo = new Date(this.paymentFormFilters.entryDateTo);
				if (tempFrom > tempTo) {
					this.paymentFormFiltersValidationEntryDate = false;
					success = false;
				} else {
					this.paymentFormFiltersValidationEntryDate = true;
				}
			} else {
				this.paymentFormFiltersValidationEntryDate = true;
			}
			if (this.paymentFormFilters.expirationFrom != null && this.paymentFormFilters.expirationTo != null) {
				let tempFrom = new Date(this.paymentFormFilters.expirationFrom);
				let tempTo = new Date(this.paymentFormFilters.expirationTo);
				if (tempFrom > tempTo) {
					this.paymentFormFiltersValidationExpirationDate = false;
					success = false;
				} else {
					this.paymentFormFiltersValidationExpirationDate = true;
				}
			} else {
				this.paymentFormFiltersValidationExpirationDate = true;
			}
			if (success) {
				let data = this.paymentFormFilters;
				this.$APICall(
					'post',
					'payment-form-members',
					data,
					(data, success) => {
						if (success) {
							this.paymentFormMembers = data.members;
							this.initialPaymentFormMembersLoad = true;
						} else {
							this.$alert(this.$t('alerts.basicError'));
						}
					},
					true
				);
			}
		},
		excelExport() {
			if (this.paymentsTable.total > 15000) {
				this.$alert(
					'Broj zapisa je prevelik za ispravni izvoz. Ograničite broj zapisa pomoću filtera pa probajte ponovno.'
				);
			} else {
				let excelRequest = JSON.parse(JSON.stringify(this.paymentsTable.lastRequest));
				excelRequest.pagination.itemsPerPage = 999999999;
				excelRequest.pagination.page = 1;

				let vm = this;
				this.$APICall(
					'get',
					'payment-forms',
					excelRequest,
					(data, success) => {
						if (success) {
							vm.$APICall('post', 'excel/payment-forms', data.items, (data, success) => {
								window.open(data.link);
							});
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					},
					true
				);
			}
		},
		resolveWindowResize() {
			this.paymentsTable.height = window.innerHeight - 310 + 'px';
		},
		generatePaymentForms(preview = false) {
			let success = true;

			if (this.paymentForm.date == null || this.paymentForm.date == '') {
				this.paymentFormValidation.date = false;
				success = false;
			} else {
				this.paymentFormValidation.date = true;
			}
			if (this.paymentForm.due_date == null || this.paymentForm.due_date == '') {
				this.paymentFormValidation.due_date = false;
				success = false;
			} else {
				this.paymentFormValidation.due_date = true;
			}
			if (this.paymentForm.default_amounts !== true) {
				if (this.paymentForm.amount == null) {
					this.paymentFormValidation.amount = false;
					success = false;
				} else {
					this.paymentFormValidation.amount = true;
				}
				if (this.paymentForm.payment_category_id == 3) {
					if (this.paymentForm.postage_amount == null) {
						this.paymentFormValidation.postage_amount = false;
						success = false;
					} else {
						this.paymentFormValidation.postage_amount = true;
					}
				}
			}
			if (this.paymentForm.payment_category_id == null) {
				this.paymentFormValidation.payment_category_id = false;
				success = false;
			} else {
				this.paymentFormValidation.payment_category_id = true;
			}
			if (this.selectedInvoiceText == null || this.selectedInvoiceText.trim() == '') {
				this.paymentFormValidation.invoice_text = false;
				success = false;
			} else {
				this.paymentFormValidation.invoice_text = true;
			}
			if (this.selectedPaymentFormMembers == null || this.selectedPaymentFormMembers.length <= 0) {
				this.$alert('Nije odabran niti jedan član');
				success = false;
			} else {
				if (this.selectedPaymentFormMembers.length > 2010) {
					this.$alert('Maksimalni broj odabranih članova je 2000. Molimo smanjite broj odabranih članova.');
					success = false;
				}
			}
			if (success) {
				this.paymentForm.selectedInvoiceText = this.selectedInvoiceText;
				this.paymentForm.selectedPaymentFormMembers = this.selectedPaymentFormMembers;
				let route = 'payment-form-create';
				if (preview) {
					route = 'payment-form-preview';
				}
				this.$APICall(
					'post',
					route,
					{ paymentForm: this.paymentForm },
					(data, success) => {
						if (success) {
							if (data.linkEmail != undefined) {
								window.open(data.linkEmail, '_blank');
							}
							if (data.linkPosta != undefined) {
								window.open(data.linkPosta, '_blank');
							}
							if (preview) {
								this.$notify(this.$t('alerts.paymentPreviewSent'));
							} else {
								this.addPaymentFormClose();
								this.$notify(this.$t('alerts.paymentCreated'));
								this.reloadData(this.paymentsTable.lastRequest);
							}
						} else {
							this.$alert(this.$t('alerts.basicError'));
						}
					},
					true
				);
			}
		},
		savePaymentClick() {
			let success = true;
			if (this.payment.date == null) {
				this.paymentValidation.date = false;
				success = false;
			} else {
				this.paymentValidation.date = true;
			}
			if (this.payment.amount == null) {
				this.paymentValidation.amount = false;
				success = false;
			} else {
				this.paymentValidation.amount = true;
			}
			if (this.payment.excerpt_number == null || this.payment.excerpt_number.trim() == '') {
				this.paymentValidation.excerpt_number = false;
				success = false;
			} else {
				this.paymentValidation.excerpt_number = true;
			}
			if (this.payment.payment_form_id == null) {
				this.paymentValidation.payment_form_id = false;
				success = false;
			} else {
				this.paymentValidation.payment_form_id = true;
			}
			if (success) {
				this.$APICall(
					'post',
					'payment',
					{ payment: this.payment },
					(data, success) => {
						if (success) {
							this.$notify(this.$t('alerts.basicAdd'));
							this.addPaymentClose();
							this.reloadData(this.paymentsTable.lastRequest);
						} else {
							this.$alert(this.$t('alerts.basicError'));
						}
					},
					true
				);
			}
		},
		getPaymentCategoryAndMember(paymentFormId) {
			if (paymentFormId != undefined && paymentFormId != null) {
				this.$APICall(
					'get',
					'payment-category-and-member/' + paymentFormId,
					{},
					(data, success) => {
						if (success) {
							this.payment.payment_category_id = data.category_id;
							this.payment.category_display = data.category_display;
							this.payment.member_id = data.member_id;
							this.payment.member_display = data.member_display;
							this.payment.amount = data.amount;
						} else {
							vm.$alert(vm.$t('alerts.basicError'));
						}
					},
					true
				);
			}
		},
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('login');
		}
		this.$myStore.commit('setBreadcrumbs', [
			{ text: this.$t('modules.payments'), href: '/#/payments', disabled: true },
		]);

		window.addEventListener('resize', this.resolveWindowResize);
		this.resolveWindowResize();
	},
};
</script>

<style>
.v-data-table__wrapper {
	scrollbar-width: thin !important;
}
</style>
